import { Box, BoxProps } from '@mui/material';
import { useCallback } from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitErrorHandler,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';

export type HookFormProps<FormValues extends FieldValues> = BoxProps<
  'form',
  {
    form: UseFormReturn<FormValues>;
    children: React.ReactNode;
    onSubmit: SubmitHandler<FormValues>;
    onError?: SubmitErrorHandler<FormValues>;
  }
>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function HookForm({ form, children, onSubmit, onError, ...props }: HookFormProps<any>) {
  const handleReset = useCallback(() => {
    form.reset({
      beneficiary: {},
    });
  }, [form]);

  return (
    <FormProvider {...form}>
      <Box
        component="form"
        noValidate
        onSubmit={form.handleSubmit(onSubmit, onError)}
        onReset={handleReset}
        {...props}
      >
        {children}
      </Box>
    </FormProvider>
  );
}
